export enum FilterViewTabEnum {
  FOLLOWING = 'following',
  ALL = 'all',
}
